import { Injectable, OnDestroy } from '@angular/core';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { Subject } from 'rxjs';
import { LoaderState } from '../../component/loader/loader';

@Injectable({
  providedIn: 'root',
})
export class LoaderService implements OnDestroy {
  private loaderSubject = new Subject<LoaderState>();
  private autoHideTimer: any = null;

  loaderState = this.loaderSubject.asObservable();

  constructor() {}
  show(loaderType?: loaderTypes) {
    loaderType = loaderType || loaderTypes.default;

    // Emit the loader state as shown
    this.loaderSubject.next(<LoaderState>{ show: true, loaderType });

    // Clear any existing timer
    if (this.autoHideTimer) {
      clearTimeout(this.autoHideTimer);
    }

    // Start a 15-second auto-hide timer
    this.autoHideTimer = setTimeout(() => {
      this.hide();
    }, 15000);
  }

  hide() {
    // Clear any pending auto-hide timer
    if (this.autoHideTimer) {
      clearTimeout(this.autoHideTimer);
      this.autoHideTimer = null;
    }

    // Emit the loader state as hidden
    this.loaderSubject.next(<LoaderState>{ show: false, loaderType: loaderTypes.none });
  }

  ngOnDestroy() {
    if (this.autoHideTimer) {
      clearTimeout(this.autoHideTimer);
      this.autoHideTimer = null;
    }
    this.loaderSubject.complete();
  }
}
